<template>
  <div id="participaciones" class="bgazul">
    <section class="">
      <div class="container pt-5">
        <div class="row text-center">
          <!-- <div class="row text-center" v-if="tickets3 != null"> -->

          <div class="col-12 py-4 mt-2 pt-5 fXG rojo bold">PARTICIPACIONES</div>

          <!-- <div class="col-12 fG text-center bold">
            <p>Tu total de la semana {{semana_corriente}} es de:</p>
            <p>
              <span class="naranja">{{suma_puntos}} puntos</span> en
              <span class="naranja">{{suma_time}}</span>
            </p>
          </div> -->

          <div class="col-12">
            <p class="azul fT  pb-3">
              Aquí puedes consultar tus participaciones
            </p>
          </div>

          <div class="col-12 col-lg-8 offset-lg-2 oscuro azul pb-5 bold">
            <table class="participaciones table-striped  fT" v-if="tickets3.length > 0">
              <thead class="">
                <!-- <th>No.</th> -->
                <!-- <th>Nombre</th> -->
                <th>Fecha</th>
                <th>Folio Único de Participación</th>
                <!-- <th>Puntos</th> -->

                <!-- <th>Status</th> -->
                <!-- <th>Ticket</th> -->
              </thead>
              <tbody>
                <tr class v-for="ticket in tickets3" :key="ticket.id">
                  <!-- <td>{{ index + 1 }}.</td> -->
                  <!-- <td>{{ userProfile.nombre + " " + userProfile.apellido }}</td> -->

                  <td>
                    {{ getFechaFormato(ticket.created_on.seconds) }}
                  </td>

                  <td>{{ ticket.boleto }}</td>

                  <!-- <td>{{ ticket.puntos }}</td> -->

                  <!-- <td>
                    <a :href="ticket.ticket_img_url" target="blank">Ver</a>
                  </td> -->
                </tr>

                <!-- <tr>
                  <td align="right">
                    <span class="azul bold px-4">Total</span>
                  </td>

                  <td class="bold bgnaranja">{{ suma_puntos }}pts</td>
                </tr> -->
              </tbody>
            </table>
          </div>


          <div class="col-12 pt-5 fG">
            <p class="text-center bold grisoscuro">
              Validaremos tus tickets en un lapso de 72 hrs.
            </p>
            <p class="text-center bold">
              Dudas o información de la promoción comunícate al 55 9435 6588 
            </p>
          </div>

          <!-- FIN PROMO 2026: se oculta Registrar otro ticket porque Dashboard quedó deshabilitado.
               Para reactivar registro de tickets, quitar v-if="false". -->
          <div class="col-12 pt-5 pb-3" v-if="false">
            <router-link
              to="/dashboard"
              type="button"
              class="btnaction w-100 fG bold px-5"
            >
              Registrar otro ticket
            </router-link>

           
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import AOS from "aos";
import { mapState } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 25;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: true,
      time: 0,
      time_txt: "",
      suma_puntos: 0,
      suma_time: 0,
      puntos_ultimo_juego: 0,
      tickets2: [],
      tickets3: [],
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      ahora: null,
      semana_corriente: "",
      multiplicador: 1,
      obj_beneficios: {},
      ids_beneficios_obtenidos: [],
      entrada_barcode_1: null,
      entrada_barcode_2: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });
    console.log({ userProfile: this.userProfile });
    //this.getTickets();
    
    setTimeout(() => {
      this.getTickets2();
    }, 200);

    //console.log({entradas: this.userProfile.entradas})
  },
  methods: {
    getMultiplicador(puntos) {
      let multiplicador = 1;
      return multiplicador * puntos;
    },
    getTiempoFormato(time) {
      return this.secondsToHms(time);
    },
    getFechaFormato(time) {
      return moment.unix(time).locale("es").format("MMM D, Y HH:mm:ss");
    },
    async getTickets2() {
      console.log("llamando tickets");
      this.$store.dispatch("showLoader", true);

      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        //.where("user_id", "==", "etiScWgR7TMIQnxEUHEcWw883NM2")
        .where("status", "in", [
          // "cerrado",
          // "cerrado en otro ticket",
          "por validar",
          "valido",
          //"invalido",
        ])
        //.where("status_juego", "==", "terminado")
        .get();

      this.tickets3 = [];
      let thes = this;
      this.suma_puntos = 0;
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;

        try {
          //ticket.score = parseInt(ticket.score) * this.multiplicador;

          ticket.score = ticket.puntos;
        } catch {
          //
        }


        try {
          //ticket.score = parseInt(ticket.score) * this.multiplicador;

          //ticket.created_on_server = ticket.created_on_server;
        } catch {
          //
          ticket.created_on_server = ticket.created_on;
        }


        thes.tickets3.push(ticket);
      });

      console.log({ ids_beneficios_obtenidos: thes.ids_beneficios_obtenidos });
      console.log({ obj_beneficios: thes.obj_beneficios });

      this.tickets3 = this.tickets3.sort(this.custom_sort);
      console.log({ tickets3_misparticipaciones: this.tickets3 });

      //this.setResumen();


      this.$store.dispatch("showLoader", false);

      //if(this.tickets3.length == 0)
    },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    async setResumen() {
      let multi = 1;

      if (this.tickets3.length > 0) {
        this.ultimo_ticket = this.tickets3[this.tickets3.length - 1];

        if (
          this.ultimo_ticket.mnms != undefined &&
          this.ultimo_ticket.mnms === true
        ) {
          multi = 2;
        }

        this.puntos_ultimo_juego = this.ultimo_ticket.puntos * multi;

        // if(this.userProfile.puntos_club_cinepolis != undefined){
        //   this.puntos_ultimo_juego += this.userProfile.puntos_club_cinepolis;
        // }
      }
      console.log({ ultimo: this.ultimo_ticket });
      console.log({ ultimo_id: this.ultimo_ticket.id });

      // console.log({ multiplicador: this.tickets });
      //console.log({ userProfile: this.userProfile });

      //await this.getAhora();
      let thes = this;
      this.semana_corriente = this.getNumSemana(this.ahora);
      //console.log({tengoahora: this.ahora});

      let week = this.getSemana(this.ahora);
      //console.log(moment().add(2, "days"));
      //console.log({ weekahora: week });
      let suma_puntos = 0;
      let suma_time = 0;
      this.tickets3.forEach((element) => {
        //console.log({ elem: element.created_on.seconds });
        let date = moment.unix(element.created_on.seconds).format("L");
        //console.log(date);
        //console.log(moment(date).week());
        let temp_week = moment(date).add(2, "days").week();
        //console.log({ weektemp: temp_week });
        //if (week == temp_week) {
        try {
          if (element.puntos != undefined) {
            multi = 1;
            if (element.mnms != undefined && element.mnms === true) {
              multi = 2;
            }

            suma_puntos = suma_puntos + parseInt(element.puntos) * multi;
          }
        } catch (err) {
          //
        }
        // suma_time = suma_time + parseInt(element.time);
        //}
      });

      if (this.userProfile.puntos_club_cinepolis != undefined) {
        suma_puntos += thes.userProfile.puntos_club_cinepolis;
      }

      this.suma_puntos = suma_puntos;
      this.suma_time = this.secondsToHms(suma_time);
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    getNumSemana(fecha) {
      let semana = parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;

      return semana;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
